// // destinations img
// import tour4 from "../assets/images/tour/Tokyo.png";
// import tour5 from "../assets/images/tour/bali-1.png";
// import tour6 from "../assets/images/tour/bangkok.png";
// import tour7 from "../assets/images/tour/cancun.png";
// import tour8 from "../assets/images/tour/nah-trang.png";
// import tour9 from "../assets/images/tour/phuket.png";
// import tour10 from "../assets/images/tour/paris.png";
// import tour11 from "../assets/images/tour/malaysia.png";

// // populars img
// import Anchorage from "../assets/images/popular/Anchorage To La Paz.jpg";
// import Singapore from "../assets/images/popular/Discover Singapore.png";
// import Kiwiana from "../assets/images/popular/Kiwiana Panorama.jpg";
// import Quito from "../assets/images/popular/Anchorage To Quito.jpg";
// import Cuzco from "../assets/images/popular/Cuzco To Anchorage.jpg";
// import Ushuaia from "../assets/images/popular/Anchorage To Ushuaia.jpg";
// import Santiago from "../assets/images/popular/Anchorage To Santiago.jpg";
// import Explorer from "../assets/images/popular/LA Explorer.jpg";

// // tour detail img
// import image1 from "../assets/images/new/1.jpg";
// import image2 from "../assets/images/new/2.jpg";
// import image3 from "../assets/images/new/3.jpg";
// import image4 from "../assets/images/new/4.jpg";
// import image5 from "../assets/images/new/5.jpg";
// import image6 from "../assets/images/new/6.jpg";
// import image7 from "../assets/images/new/7.jpg";
// import image8 from "../assets/images/new/8.jpg";

// export const destinationsData = [
//   {
//     id: 0,
//     name: "Bali",
//     tours: "5 tours and activities",
//     image: tour5,
//     link: "tour-name",
//     shortDes: "",
//   },
//   {
//     id: 1,
//     name: "Tokyo",
//     tours: "9 tours and activities",
//     image: tour4,
//     link: "tour-name",
//   },

//   {
//     id: 2,
//     name: "Bangkok",
//     tours: "5 tours and activities",
//     image: tour6,
//     link: "tour-name",
//   },

//   {
//     id: 3,
//     name: "Cancun",
//     tours: "4 tours and activities",
//     image: tour7,
//     link: "tour-name",
//   },
//   {
//     id: 4,
//     name: "Nha Trang",
//     tours: "9 tours and activities ",
//     image: tour8,
//     link: "tour-name",
//   },
//   {
//     id: 5,
//     name: "Phuket",
//     tours: "4 tours and activities",
//     image: tour9,
//     link: "tour-name",
//   },
//   {
//     id: 6,
//     name: "Paris",
//     tours: "6 tours and activities",
//     image: tour10,
//     link: "tour-name",
//   },
//   {
//     id: 7,
//     name: "Malaysia",
//     tours: "4 tours and activities",
//     image: tour11,
//     link: "tour-name",
//   },
// ];

// export const popularsData = [
//   {
//     id: 0,
//     title: "Discover Singapore",
//     image: Singapore,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["Escorted Tour", "Rail Tour"],
//     days: "5 days - 4 nights",
//     price: 100,
//     afterDiscount: 92,
//     rating: 3,
//     reviews: 5,
//   },
//   {
//     id: 1,
//     title: "Kiwiana Panorama",
//     image: Kiwiana,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["River Cruise", "Wildlife"],
//     days: "2 days - 1 nights",
//     price: 87,
//     afterDiscount: 82,
//     rating: 4,
//     reviews: 9,
//   },
//   {
//     id: 2,
//     title: "Anchorage To Quito",
//     image: Quito,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["Escorted Tour", "River Cruise"],
//     days: "2 days - 1 nights",
//     price: 87,
//     afterDiscount: 82,
//     rating: 4,
//     reviews: 9,
//   },
//   {
//     id: 3,
//     title: "Anchorage To La Paz",
//     image: Anchorage,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["River Cruise", "Rail Tour"],
//     days: "unlimited",
//     price: 434,
//     afterDiscount: 0,
//     rating: 5,
//     reviews: 20,
//   },
//   {
//     id: 4,
//     title: "Cuzco To Anchorage",
//     image: Cuzco,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["River Cruise", "Tour & Cruise"],
//     days: "1 days - 9 hours",
//     price: 395,
//     afterDiscount: 0,
//     rating: 3,
//     reviews: 12,
//   },
//   {
//     id: 5,
//     title: "Anchorage To Ushuaia",
//     image: Ushuaia,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["Escorted Tour", "Wildlife"],
//     days: "5 days - 4 nights",
//     price: 93,
//     afterDiscount: 0,
//     rating: 3,
//     reviews: 12,
//   },
//   {
//     id: 6,
//     title: "Anchorage To Santiago",
//     image: Santiago,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["Escorted Tour", "Wildlife"],
//     days: "1 day - 1 night",
//     price: 42,
//     afterDiscount: 0,
//     rating: 5,
//     reviews: 18,
//   },
//   {
//     id: 7,
//     title: "LA Explorer",
//     image: Explorer,
//     location: "European Way, Southampton, United Kingdom",
//     category: ["Rail Tour", "Tour & Cruise"],
//     days: "1 night",
//     price: 99,
//     afterDiscount: 0,
//     rating: 4,
//     reviews: 22,
//   },
// ];

// export const tourDetails = {
//   title: "Beautiful Bali with Malaysia",
//   des: ` Bali, also known as the land of gods has plenty to offer to travelers from across the globe. As it so contrasted oh estimating instrument. Size like body some one had.  Are conduct viewing boy minutes warrant the expense?  Tolerably behavior may admit daughters offending her ask own. Praise effect wishes change way and any wanted.  Lively use looked latter regard had. Do he it part more  last in. We understand that theory is important to build a solid foundation, we understand that theory alone isn’t going to get the job done so that’s why this is packed with practical hands-on examples that you can  follow step by step.`,
//   price: "280.00",
//   rating: " 4.5",
//   reviews: "365 reviews",
//   tourInfo: [
//     '<strong className="font-bold"> Place Covered</strong>: Bali - Ubud',
//     ' <strong className="font-bold">Duration:</strong>5 Days, 4 Nights',
//     '<strong className="font-bold">Start Point:</strong> Ngurah International Airport',
//     '<strong className="font-bold">End Point:</strong>  Ngurah International Airport',
//   ],

//   highlights: [
//     " Experience a delightful tropical getaway with a luxurious stay and witness the picture-perfect beaches, charming waterfalls and so much more",
//     " Dependent on so extremely delivered by. Yet no jokes  worse her why. Bed one supposing breakfast day fulfilled off depending questions.",
//     " Whatever boy her exertion his extended. Ecstatic  followed handsome drawings entirely Mrs one yet  outweigh.",
//     "Meant balls it if up doubt small purse. Required his  you put the outlived answered position. A pleasure exertion if believed provided to.",
//   ],

//   itinerary: [
//     {
//       title: `<span class="me-1 fw-bold">Day 1:</span>  Airport Pick Up `,
//       des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
//     },

//     {
//       title: `<span class="me-1 fw-bold">Day 2:</span>  Temples & River Cruise `,
//       des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in. `,
//     },
//     {
//       title: `<span class="me-1 fw-bold">Day 3:</span>  Massage & Overnight Train`,
//       des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
//     },
//     {
//       title: `<span class="me-1 fw-bold">Day 4:</span>  Khao Sok National Park `,
//       des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
//     },
//     {
//       title: `<span class="me-1 fw-bold">Day 5:</span>  Travel to Koh Phangan `,
//       des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.
//       `,
//     },
//     {
//       title: `<span class="me-1 fw-bold">Day 6:</span> Morning Chill & Muay Thai Lesson `,
//       des: `Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.
//       `,
//     },
//   ],

//   included: [
//     "Comfortable stay for 4 nights in your preferred category Hotels",
//     "Professional English speaking guide to help you explore the cities",
//     "Breakfast is included as mentioned in Itinerary.",
//     "Per Peron rate on twin sharing basis",
//     "Entrance Tickets to Genting Indoor Theme Park    ",
//     "All Tours & Transfers on Seat In Coach Basis ",
//     "Visit Bali Safari & Marine Park with Jungle Hopper Pass    ",
//   ],
//   exclusion: [
//     "Lunch and dinner are not included in CP plans",
//     "Any other services not specifically mentioned in the inclusions",
//     "Medical and Travel insurance",
//     "Airfare is not included ",
//     "Early Check-In & Late Check-Out ",
//     "Anything which is not specified in Inclusions    ",
//   ],

//   images: [
//     {
//       original: image1,
//       thumbnail: image1,
//     },
//     {
//       original: image2,
//       thumbnail: image2,
//     },
//     {
//       original: image3,
//       thumbnail: image3,
//     },
//     {
//       original: image4,
//       thumbnail: image4,
//     },
//     {
//       original: image5,
//       thumbnail: image5,
//     },

//     {
//       original: image6,
//       thumbnail: image6,
//     },
//     {
//       original: image7,
//       thumbnail: image7,
//     },
//     {
//       original: image8,
//       thumbnail: image8,
//     },
//   ],
// };

// export const location = [
//   "Bali",
//   "Tokyo",
//   "Bangkok",
//   "Cancun",
//   "Nha Trang",
//   "Phuket",
//   "Malaysia",
//   "Paris",
// ];

// export const Categories = [
//   "History",
//   "Calture",
//   "Netural",
//   "Urban Tour",
//   "Relax",
// ];

// export const Duration = ["1-3 Days", "3-5 Days", "5-7 Days", "7-10 Day"];
// export const PriceRange = [
//   "$ 0 - $50",
//   "$ 50 - $ 100",
//   "$ 100 - $ 200",
//   "$ 200 - ₹ $ 400",
//   "$ 400 - ₹ $ 800",
// ];

// export const Ratings = ["⭐", "⭐⭐", "⭐⭐⭐", "⭐⭐⭐⭐", "⭐⭐⭐⭐⭐"];

// // // India / Gujarat images (make sure these images exist)


// // export const destinationsData = [
// //   {
// //     id: 0,
// //     name: "Dwarka",
// //     tours: "4 tours and activities",
// //     image: 'https://www.daiwikhotels.com/wp-content/uploads/2024/08/Lord-Krishnas-City-1.jpg',
// //     link: "dwarka-tour",
// //   },
// //   {
// //     id: 1,
// //     name: "Somnath Temple",
// //     tours: "6 tours and activities",
// //     image: 'https://templemitra.com/files/assets/images/product/68089templemitra.jpg',
// //     link: "somnath-tour",
// //   },
// //   {
// //     id: 2,
// //     name: "Rann of Kutch",
// //     tours: "5 tours and activities",
// //     image: 'https://www.rannutsavgujarat.in/thumb/media/0x600/fLwcdhrZsXKnmCSw6YFJN7jFE5RtP9zT.jpg',
// //     link: "kutch-tour",
// //   },
// //   {
// //     id: 3,
// //     name: "Gir National Park",
// //     tours: "3 tours and activities",
// //     image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2vrM20jVeWSagwwAH1mIgnzj2-J9PnEVsVg&s',
// //     link: "gir-tour",
// //   },
// //   {
// //     id: 4,
// //     name: "Statue of Unity",
// //     tours: "7 tours and activities",
// //     image: 'https://www.financialexpress.com/wp-content/uploads/2018/10/SardarpatelStatueofUnity.jpg',
// //     link: "statue-of-unity-tour",
// //   },
// //   {
// //     id: 5,
// //     name: "Udaipur",
// //     tours: "5 tours and activities",
// //     image: 'https://www.thehosteller.com/_next/image/?url=https%3A%2F%2Fstatic.thehosteller.com%2Fhostel%2Fimages%2Fcover%20photo.jpg%2Fcover%20photo-1696914123916.jpg&w=2048&q=75',
// //     link: "udaipur-tour",
// //   },
// //   {
// //     id: 6,
// //     name: "Taj Mahal",
// //     tours: "8 tours and activities",
// //     image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwQuoHlFI7JMLexdj23Ox3e0B-BwAN3gFDSw&s',
// //     link: "taj-mahal-tour",
// //   },
// //   {
// //     id: 7,
// //     name: "Jaipur",
// //     tours: "4 tours and activities",
// //     image: 'https://www.agoda.com/wp-content/uploads/2024/02/Nahargath-Fort-Jaipur-India-1050x700.jpg',
// //     link: "jaipur-tour",
// //   },
// // ];

export const destinationsData = [
  {
    id: 0,
    name: "Dwarka, Gujarat",
    tours: "4 tours and activities",
    image: "https://www.daiwikhotels.com/wp-content/uploads/2024/08/Lord-Krishnas-City-1.jpg",
    link: "dwarka-tour",
  },
  {
    id: 1,
    name: "Somnath Temple, Gujarat",
    tours: "6 tours and activities",
    image: "https://templemitra.com/files/assets/images/product/68089templemitra.jpg",
    link: "somnath-tour",
  },
  {
    id: 2,
    name: "Rann of Kutch, Gujarat",
    tours: "5 tours and activities",
    image: "https://www.rannutsavgujarat.in/thumb/media/0x600/fLwcdhrZsXKnmCSw6YFJN7jFE5RtP9zT.jpg",
    link: "kutch-tour",
  },
  {
    id: 3,
    name: "Gir National Park, Gujarat",
    tours: "3 tours and activities",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2vrM20jVeWSagwwAH1mIgnzj2-J9PnEVsVg&s",
    link: "gir-tour",
  },
  {
    id: 4,
    name: "Statue of Unity, Gujarat",
    tours: "7 tours and activities",
    image: "https://www.financialexpress.com/wp-content/uploads/2018/10/SardarpatelStatueofUnity.jpg",
    link: "statue-of-unity-tour",
  },
  {
    id: 5,
    name: "Udaipur, Rajasthan",
    tours: "5 tours and activities",
    image: "https://www.thehosteller.com/_next/image/?url=https%3A%2F%2Fstatic.thehosteller.com%2Fhostel%2Fimages%2Fcover%20photo.jpg%2Fcover%20photo-1696914123916.jpg&w=2048&q=75",
    link: "udaipur-tour",
  },
  {
    id: 6,
    name: "Taj Mahal, Agra",
    tours: "8 tours and activities",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwQuoHlFI7JMLexdj23Ox3e0B-BwAN3gFDSw&s",
    link: "taj-mahal-tour",
  },
  {
    id: 7,
    name: "Jaipur, Rajasthan",
    tours: "4 tours and activities",
    image: "https://www.agoda.com/wp-content/uploads/2024/02/Nahargath-Fort-Jaipur-India-1050x700.jpg",
    link: "jaipur-tour",
  },
];

export const popularsData = [
  {
    id: 0,
    title: "Statue of Unity Weekend Tour",
    image: "https://www.financialexpress.com/wp-content/uploads/2018/10/SardarpatelStatueofUnity.jpg",
    location: "Kevadiya, Gujarat",
    category: ["Cultural", "Sightseeing"],
    days: "2 days - 1 night",
    price: 150,
    afterDiscount: 130,
    rating: 4,
    reviews: 25,
  },
  {
    id: 1,
    title: "Rann of Kutch Desert Festival",
    image: "https://www.rannutsavgujarat.in/thumb/media/0x600/fLwcdhrZsXKnmCSw6YFJN7jFE5RtP9zT.jpg",
    location: "Kutch, Gujarat",
    category: ["Festival", "Culture"],
    days: "3 days - 2 nights",
    price: 200,
    afterDiscount: 180,
    rating: 5,
    reviews: 40,
  },
];

export const tourDetails = {
  title: "Rann of Kutch Festival Special",
  des: "Explore the vast salt desert of Kutch during the famous Rann Utsav. Enjoy folk music, traditional dances, local food, and vibrant culture.",
  price: "250.00",
  rating: "4.7",
  reviews: "128 reviews",
  tourInfo: [
    '<strong className="font-bold">Place Covered:</strong> White Rann - Bhuj',
    '<strong className="font-bold">Duration:</strong> 3 Days, 2 Nights',
    '<strong className="font-bold">Start Point:</strong> Bhuj Railway Station',
    '<strong className="font-bold">End Point:</strong> Bhuj Railway Station',
  ],
  highlights: [
    "Cultural performances under full moon night",
    "Luxury tent stay with local food",
    "Visit nearby villages and handicraft shops",
    "Sunset at White Desert viewpoint",
  ],
  itinerary: [
    {
      title: "Day 1: Arrival and Check-in",
      des: "Arrive at Bhuj and transfer to tent city. Enjoy local snacks and evening cultural performances.",
    },
    {
      title: "Day 2: Village Tour & Desert Sunset",
      des: "Explore nearby traditional villages, shop for handicrafts, and enjoy sunset in white desert.",
    },
    {
      title: "Day 3: Return",
      des: "Check-out after breakfast and transfer to Bhuj.",
    },
  ],
  included: [
    "Tent Stay (AC / Non-AC Options)",
    "All Meals - Gujarati Thali",
    "Local Guided Tour",
    "Pick-up/Drop from Bhuj",
  ],
  exclusion: [
    "Airfare / Train Tickets",
    "Personal Expenses",
    "Anything not mentioned in inclusions",
  ],
  images: [],
};

export const location = [
  "Dwarka",
  "Somnath",
  "Rann of Kutch",
  "Gir",
  "Statue of Unity",
  "Udaipur",
  "Taj Mahal",
  "Jaipur",
];

export const Categories = [
  "Cultural",
  "Religious",
  "Heritage",
  "Festival",
  "Nature",
];

export const Duration = ["1-2 Days", "3-5 Days", "5-7 Days", "7+ Days"];

export const PriceRange = [
  "₹ 0 - ₹1000",
  "₹ 1000 - ₹ 5000",
  "₹ 5000 - ₹ 10000",
  "₹ 10000+",
];

export const Ratings = ["⭐", "⭐⭐", "⭐⭐⭐", "⭐⭐⭐⭐", "⭐⭐⭐⭐⭐"];


